import { loadComponents } from "loadable-components";
import { config } from "../../config/client";
import pathDeobfuscate from "../../helpers/pathDeobfuscate";
import get from "lodash/get";
import set from "lodash/set";
import unset from "lodash/unset";

const loadDynamicComponents = async () => {
  const {
    globalKeys: { loadableKey, loadableDefaultKey }
  } = config;
  const loadableState = get(window, loadableKey);

  unset(window, loadableKey);

  const finalLoadableState = {
    ...loadableState,
    children: loadableState.children.map(({ id, ...rest }) => ({
      ...rest,
      id: pathDeobfuscate(id)
    }))
  };

  set(window, loadableDefaultKey, finalLoadableState);

  await loadComponents();

  unset(window, loadableDefaultKey);
};

export default loadDynamicComponents;
